import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
import { classNames } from '@standardnotes/snjs';
export const ListItemTitle = ({ item }) => {
    return (_jsxs("div", { className: classNames('break-word mr-2 overflow-hidden text-lg font-semibold leading-[1.3] lg:text-base lg:leading-[1.3]', item.archived ? 'opacity-60' : ''), children: [item.pinned && (_jsx("span", { className: "mr-1.5 inline-flex rounded-full bg-info p-0.5 text-info-contrast", children: _jsx(Icon, { type: "pin-filled", size: "custom", className: "h-3 w-3" }) })), item.title] }));
};
